import { render, staticRenderFns } from "./ItemCategoryGroup.vue?vue&type=template&id=55eb2498"
import script from "./ItemCategoryGroup.vue?vue&type=script&lang=js"
export * from "./ItemCategoryGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports